'use client'
import { HeartIcon } from '@heroicons/react/24/outline';
import { HeartIcon as HeartIconFill } from '@heroicons/react/24/solid';
import { use, useCallback, useEffect, useState } from 'react';
import _debounce from 'lodash/debounce';
import { useAddToFavouritesMutation, useGetFavouriteListQuery, useRemoveFromFavouritesMutation } from 'lib/services/favourite';
import { useAuthentication } from 'hooks/useAuthentication';
import isEmpty from 'utilities/isEmpty';
import { useAuthWallFunction } from 'hooks/useAuthWallFunction';
import { alertSuccess } from 'components/controls/functions/alerts';

export default function FavouriteToggle({ data, render }) {
    const { isAuthenticated } = useAuthentication();
    const { data: favourites, isLoadingFavourites, isFetchingFavourites } = useGetFavouriteListQuery([], { skip: !isAuthenticated });
    const [isFavourite, setIsFavourite] = useState(!isEmpty(favourites) ? !isEmpty(favourites[data.id]) : null);

    useEffect(() => {
        if (isEmpty(isFavourite) && !isEmpty(favourites)) {
            setIsFavourite(!isEmpty(favourites[data.id]));
        }
    }, [data.id, favourites, isFavourite]);

    const [
        addToFavourites,
        { isLoading: isAdding },
    ] = useAddToFavouritesMutation();

    const [
        removeFromFavourites,
        { isLoading: isRemoving, },
    ] = useRemoveFromFavouritesMutation();



    const handleAddToFavourites = async () => {
        await addToFavourites({ spaceIdentifierId: data.id });
    };

    const handleRemoveFromFavourites = async () => {
        await removeFromFavourites({ spaceIdentifierId: data.id });
    }

    const debounceToggleIsFavourite = useCallback(_debounce(async (isFavouriteDebound) => isFavouriteDebound ? await handleRemoveFromFavourites() : await handleAddToFavourites(), 500), []);


    const handleToggleIsFavourite = useAuthWallFunction(async (e) => {
        setIsFavourite(!isFavourite);

        debounceToggleIsFavourite(isFavourite);
    });


    return render(isFavourite, data?.favouriteCount ?? 0, handleToggleIsFavourite);
}